import { Fragment, useEffect, useRef, useState } from 'react';
import Spinner from '../../../components/spinner/Spinner';
import './CompaniesList.css';
import { DeleteSalesCompany, GetCurrentUserSalesCompanies } from '../../../Services';
import { Link, useNavigate } from 'react-router-dom';
import PageHeadline from '../../../components/pageHeadline/PageHeadline';
import Moment from 'react-moment';
import TableFooter from '../../../components/table/footer/TableFooter';
import { useStateValue } from '../../../StateProvider';
import { toast } from 'react-toastify';

const CompaniesList = ({ selectBusinessForReport = false }) => {
	const [ isLoading, setIsLoading ] = useState(false);
	const [ companiesList, setCompaniesList ] = useState([]);
	const [ companiesListListView, setCompaniesListListView ] = useState();
	const searchListInputRef = useRef();
	const [ { user }, dispatch ] = useStateValue();
	const navigate = useNavigate();

	useEffect(() => {
		document.title = 'Companies';

		getCompanies(true);
	}, []);

	const filterList = () => {
		if (companiesList && companiesList.length > 0) {
			let tempCompaniesList = applySearchFilter(companiesList, true);
			setCompaniesListListView(tempCompaniesList);
		} else {
			setCompaniesListListView([]);
		}
	};

	const onSearchChange = (e) => {
		if (searchListInputRef.current) {
			if (searchListInputRef.current.value === '') {
				searchListInputRef.current.classList.remove('has-value');
			} else {
				searchListInputRef.current.classList.add('has-value');
			}
		}

		filterList();
	};

	const applySearchFilter = (companiesList) => {
		if (companiesList) {
			if (searchListInputRef.current && searchListInputRef.current.value) {
				companiesList = companiesList.filter((x) => {
					let nameCond = x.name.toLowerCase().includes(searchListInputRef.current.value.toLowerCase());
					let emailCond =
						x.email && x.email !== ''
							? x.email.toLowerCase().includes(searchListInputRef.current.value.toLowerCase())
							: false;
					let userEmailCond =
						x.userEmail && x.userEmail !== ''
							? x.userEmail.toLowerCase().includes(searchListInputRef.current.value.toLowerCase())
							: false;

					return nameCond || emailCond || userEmailCond;
				});
			}
		}

		return companiesList;
	};

	const getCompanies = async (fullReload = false) => {
		if (fullReload) {
			setIsLoading(true);
		}

		let response = await GetCurrentUserSalesCompanies();

		if (response.IsSuccessful === false) {
			if (
				response.Message &&
				response.Message.response &&
				response.Message.response.status &&
				response.Message.response.status === 401
			) {
				//navigate('/login');
			}
		}

		if (response && response.length) {
			let tempCompaniesList = response;

			tempCompaniesList = tempCompaniesList.sort((a, b) => a.name.localeCompare(b.name));
			tempCompaniesList = applySearchFilter(tempCompaniesList);

			setCompaniesList(tempCompaniesList);
			setCompaniesListListView(tempCompaniesList);
		} else {
			setCompaniesListListView([]);
		}

		setIsLoading(false);
	};

	const handleSelectBusiness = (businessId) => {
		if (businessId) {
			window.location.href = `/reports/${businessId}/new`;
		}
	};

	const handleNewBusiness = () => {
		navigate('/profile-connect/new');
	};

	const handleDeleteCompany = async (e, companyId) => {
		e.preventDefault();

		if (
			window.confirm('All reports will be also deleted. Are you sure that you want to delete selected company?')
		) {
			const response = await DeleteSalesCompany(companyId);

			if (response.success) {
				toast.success('Company successfully deleted');

				getCompanies();
			} else {
				console.log('Failed while delete company: ' + companyId + '; ' + response.message);
			}
		}
	};

	return (
		<Fragment>
			<div className="row">
				<div className="col-12">
					<PageHeadline
						headline={selectBusinessForReport ? 'Select Company' : ''}
						showSearchBox={true}
						leftSideHtml={
							selectBusinessForReport ? (
								<Fragment />
							) : (
								<Fragment>
									<button type="button" className="btn btn-primary" onClick={handleNewBusiness}>
										<span>New Company</span>
									</button>
								</Fragment>
							)
						}
						buttonsHtml={
							<Fragment>
								<div className="d-flex justify-content-end">
									<div className="search-list-wrapper align-self-start">
										<input
											type="search"
											className="form-control"
											name="searchListTerm"
											onChange={onSearchChange}
											placeholder="Search List"
											ref={searchListInputRef}
											tabIndex="0"
										/>
										<button type="button" className="btn btn-link btn-search px-2">
											<i className="fa fa-search me-0" />
										</button>
									</div>
								</div>
							</Fragment>
						}
					/>
				</div>
			</div>

			<Fragment>
				<div className="main-content-container companies-list-container">
					<div className="main-content-inner-container">
						<div className="table-wrapper">
							<table className="items-list companies-list table table-responsive">
								<thead>
									<tr>
										<th className="business-name" scope="col">
											Name
										</th>
										<th className="date d-none d-sm-table-cell" scope="col">
											Date
										</th>
										{/* <th className="date d-none d-sm-table-cell text-center" scope="col">
											Total Reports
										</th> */}
										<th className="task-action" scope="col" />
									</tr>
								</thead>
								{isLoading || !companiesListListView ? (
									<tbody>
										<tr>
											<td className="p-3" colSpan={5}>
												<Spinner />
											</td>
										</tr>
									</tbody>
								) : (
									<tbody>
										{companiesListListView && companiesListListView.length > 0 ? (
											companiesListListView.map((business, index) => {
												return (
													<Fragment key={index}>
														<tr>
															<td
																className="business-name text-truncate"
																title={`${business.name}${business.nameExtension
																	? ` - ${business.nameExtension}`
																	: ''}`}
															>
																{`${business.name}${business.nameExtension
																	? ` - ${business.nameExtension}`
																	: ''}`}
																{business.googleCid ? (
																	<a
																		className="btn btn-link p-0"
																		href={`https://google.com/maps/?cid=${business.googleCid}`}
																		target="_blank"
																		title="View Google Business Profile"
																	>
																		<i className="fa-solid fa-arrow-up-right-from-square ms-2" />
																	</a>
																) : (
																	<Fragment />
																)}
															</td>
															<td className="date d-none d-sm-table-cell">
																{business.dateCreated ? (
																	<Moment format="MM/DD/YYYY">
																		{business.dateCreated}
																	</Moment>
																) : (
																	''
																)}
															</td>
															{/* <td className="date d-none d-sm-table-cell text-center">
																{business.reportSentHistoryRecordsCount || ''}
															</td> */}
															<td className="task-action text-end">
																{selectBusinessForReport ? (
																	<button
																		className="btn btn-link p-0"
																		onClick={() =>
																			handleSelectBusiness(business.id)}
																	>
																		Select
																	</button>
																) : (
																	<button
																		type="button"
																		className="btn btn-link py-0 text-danger"
																		title="Delete Company"
																		onClick={(e) =>
																			handleDeleteCompany(e, business.id)}
																	>
																		<i className="fa-solid fa-trash-can" />
																	</button>
																)}
															</td>
														</tr>
													</Fragment>
												);
											})
										) : (
											<tr>
												<td className="p-3" colSpan={5}>
													<i>No companies</i>
												</td>
											</tr>
										)}
									</tbody>
								)}

								{!isLoading && (
									<TableFooter
										list={companiesListListView}
										colspan={10}
										showRefreshButton={true}
										onListRefresh={() => getCompanies(true)}
									/>
								)}
							</table>
						</div>

						{selectBusinessForReport && (
							<div className="new-business-wrapper">
								{/* or */}
								<Link to="/profile-connect" className="btn btn-primary">
									Create New Company
								</Link>
							</div>
						)}
					</div>
				</div>
			</Fragment>
		</Fragment>
	);
};

export default CompaniesList;
